import { render } from "./cfParametersComponent.vue?vue&type=template&id=5b2feeba&scoped=true"
import script from "./cfParametersComponent.vue?vue&type=script&lang=js"
export * from "./cfParametersComponent.vue?vue&type=script&lang=js"

import "./cfParametersComponent.vue?vue&type=style&index=0&id=5b2feeba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2feeba"]])

export default __exports__